import React, { useState, useEffect, useRef } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Submit } from "../../component/icons";
import InputField from "../../component/input-field";
import Table, { TableRow } from "../../component/table";
import SearchForm from "../../component/search-form";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "immutability-helper";
import swal from "@sweetalert/with-react";
import ActivitySideList from "./ActivitySideList";
import "../../css/theme.css";
import CustomeModal from "../../component/modal-popup/customeModal";

// Adding new tooltip
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional

// Import Redux Actions and redux hooks
import { useDispatch, useSelector } from "react-redux";
import {
  getHeaderName,
  createConfiguration,
  createConfigurationSettingMappingBulk,
  getConfigurationDataWithSetting,
  handleDeleteConfigurationSetting,
  handleUpdateConfigurationSetting,
  handleAddHeader,
  handleUpdateConfigurationName,
  getActivityConfigurationSettingMapping,
} from "../../redux/actions/configurationAction";
import {
  RESET_SAVE_TEMPORARY_DATA,
  SAVE_TEMPORARY_DATA,
  REMOVE_CONFIGURATION_ID,
} from "../../redux/constants/index";
import { sanitizeInput } from "../../utils";

function CreateConfiguration(props) {
  const [step, setStep] = useState(1);
  const [activityCardList, setActivityCardList] = useState([]);
  const [activityCardListForStack, setActivityCardListForStack] = useState([]);
  const taskItem = [];
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [payloadState, setPayloadState] = useState();

  const location = useLocation();
  const parentConfiguration = location.state;

  // Get Dispatch and redux states
  const dispatch = useDispatch();
  const { activityListForCards } = useSelector((state) => state.todo);
  const { configurationID } = useSelector(
    (state) => state.configurationReducer
  );
  const { saveData, tempPageName } = useSelector(
    (state) => state.tempWindowsData
  );

  let payloadData = [];

  const handleCreateTask = (task) => {
    const taskItemElement = {
      id: Math.floor(Math.random() * 1000),
      name: task.configurationName?.trim(),
      label: task.headerName?.trim(),
      value: task.configurationValue,
    };
    taskItem.push(taskItemElement);
    task.setConfigurations(taskItem);
    task.setheaderName("");
    task.setConfigurationValue("");
  };

  const handleCreateConfiguration = async (data) => {
    const configurationSettingArray = [];
    let body;

    data.configurations.forEach((element) => {
      if (element.label && element.value) {
        const configurationSettingObj = {
          header_name: element.label,
          header_value: element.value,
        };
        configurationSettingArray.push(configurationSettingObj);
      }
    });

    if (configurationSettingArray.length !== 0) {
      body = {
        configuration_name: data.configurationName?.trim(),
        configuration_desc: data.description?.trim(),
        configuration_settings: configurationSettingArray,
      };
    } else {
      body = {
        configuration_name: data.configurationName?.trim(),
        configuration_desc: data.description?.trim(),
      };
    }

    const request = {
      onSuccess: (response) => {
        setStep(2);
      },
      body,
      onError: (error) => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={
                error?.message === "Duplicate entry"
                  ? "This workflow name is already used, try another name"
                  : "Something went wrong. Please try again later."
              }
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(createConfiguration(request));
  };

  const addRemoveAcitivity = (element, index) => {
    let check = false;
    element.sequence = index + 1;

    // Remove activity from table
    for (const activity of activityCardList) {
      if (activity.id === element.id) {
        const remainingActivity = activityCardList.filter(
          (item) => item.id !== element.id
        );
        payloadData = payloadData
          .filter((activity) => activity.activity_id !== element.id)
          .map((workflow) => {
            if (workflow.loop_activity === element.id) {
              workflow.loop_activity = null;
            }
            if (workflow.link_activity === element.id) {
              workflow.link_activity = null;
            }
            return workflow;
          });

        setPayloadState(payloadData);
        setActivityCardList(remainingActivity);
        check = true;
        break;
      } else {
        check = false;
      }
    }

    // Add remove activity for activityStackList.
    if (activityCardListForStack.length > 0) {
      for (const stackActivity of activityCardListForStack) {
        if (stackActivity.id === element.id) {
          const remainingActivity = activityCardListForStack.filter(
            (item) => item.id !== element.id
          );
          setActivityCardListForStack(remainingActivity);
        }
      }
    }

    // Add Activity to Table
    if (!check) {
      setActivityCardList((activityCardList) => [...activityCardList, element]);
      return check;
    }
    return check;
  };

  // Creating mapping
  const handleSubmit = async (payloadState) => {
    try {
      let payloadData = [];
      payloadState.map((element, index) => {
        let obj;
        if (element.link_activity === "" && element.loop_activity === "") {
          obj = {
            configuration_id: element.configuration_id,
            activity_id: element.activity_id,
            name: element.name,
            sequence: index + 1,
            is_mandatory: element.is_mandatory,
            duration: Number(element.duration),
          };
        } else if (element.link_activity === "") {
          obj = {
            configuration_id: element.configuration_id,
            activity_id: element.activity_id,
            name: element.name,
            sequence: index + 1,
            is_mandatory: element.is_mandatory,
            duration: Number(element.duration),
            loop_activity: element.loop_activity,
          };
        } else if (
          element.loop_activity === "" &&
          element.activity_customfields_id === ""
        ) {
          obj = {
            configuration_id: element.configuration_id,
            activity_id: element.activity_id,
            name: element.name,
            sequence: index + 1,
            is_mandatory: element.is_mandatory,
            duration: Number(element.duration),
            link_activity: element.link_activity,
          };
        } else if (element.loop_activity && element.activity_customfields_id) {
          obj = {
            configuration_id: element.configuration_id,
            activity_id: element.activity_id,
            name: element.name,
            sequence: index + 1,
            is_mandatory: element.is_mandatory,
            duration: Number(element.duration),
            link_activity: element.link_activity,
            activity_customfields_id: element.activity_customfields_id,
          };
        } else if (!element.activity_customfields_id) {
          obj = {
            configuration_id: element.configuration_id,
            activity_id: element.activity_id,
            name: element.name,
            sequence: index + 1,
            is_mandatory: element.is_mandatory,
            duration: Number(element.duration),
            link_activity: element.link_activity,
            loop_activity: element.loop_activity,
          };
        } else {
          obj = {
            configuration_id: element.configuration_id,
            activity_id: element.activity_id,
            name: element.name,
            sequence: index + 1,
            is_mandatory: element.is_mandatory,
            duration: Number(element.duration),
            link_activity: element.activity_id,
            loop_activity: element.loop_activity,
            activity_customfields_id: element.activity_customfields_id,
          };
        }
        payloadData.push(obj);
      });
      const body = payloadData;
      const request = {
        body,
        onSuccess: () => {
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content="Workflow has been created successfully."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          dispatch({ type: REMOVE_CONFIGURATION_ID });
          if (tempPageName === "manage workflow") {
            dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
          }
          navigate(`/workflows`);
        },
        onError: () => {
          setError(error);
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content="Something went wrong. Please try again later."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        },
      };
      dispatch(createConfigurationSettingMappingBulk(request));
    } catch (error) {
      setError(error);
      swal({
        content: (
          <CustomeModal
            type="error"
            title="Error!"
            content="Something went wrong. Please try again later."
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }
  };

  // Creating reference for table height
  const tableHeightRef = useRef(null);

  // Creating function to add default activity
  const addDefaultActivity = (defaultActivity) => {
    setActivityCardList(defaultActivity);
  };

  // Setting default activity
  useEffect(() => {
    if (tempPageName === "manage workflow") {
      setPayloadState(saveData.payloadState);
      setActivityCardList(saveData.activityCardList);
    }
  }, [activityListForCards]);

  const handleNavigation = () => {
    const payload = {
      path: location.pathname,
      tempPageName: "manage workflow",
      saveData: { payloadState, activityCardList },
    };

    // console.log({ payloadState, activityCardList });

    dispatch({ type: SAVE_TEMPORARY_DATA, payload });
    navigate("/activity/create");
  };

  // Function to get Parent Configuration Setting Data for copying configuration
  const getConfigurationMapping = async () => {
    const request = {
      configuration_id: parentConfiguration,
      onSuccess: (response) => {
        const arr = [];
        response.map((element) => {
          const obj = element;
          obj.id = element.activity.id;
          obj.activity_id = element.activity.id;
          obj.name = element.activity.name;
          delete obj.configuration_setting_mapping_id;
          const isLinkActivityExist = response.filter(
            (data) => data.activity.id === element.link_activity
          );
          const isLoopActivityExist = response.filter(
            (data) => data.activity.id === element.loop_activity
          );
          if (isLoopActivityExist.length === 0) {
            obj.loop_activity = null;
          }
          if (isLinkActivityExist.length === 0) {
            obj.link_activity = null;
            obj.duration = 0;
            obj.activity_customfields_id = null;
          }
          arr.push(obj);
        });
        setPayloadState(arr);
        setActivityCardList(arr);
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getActivityConfigurationSettingMapping(request));
  };

  useEffect(() => {
    if (parentConfiguration) {
      getConfigurationMapping();
    }
  }, []);

  return (
    <form className="min-h-full bg-white sm:mx-6 lg:mx-8">
      <div className="sm:flex">
        {step === 2 && (
          <ActivitySideList
            addRemoveAcitivity={addRemoveAcitivity}
            activityCardList={activityCardList}
            setActivityCardList={setActivityCardList}
            tableHeightRef={tableHeightRef}
            addDefaultActivity={addDefaultActivity}
            handleNavigation={handleNavigation}
          />
        )}
        <div className={`${step === 2 ? "md:w-3/4 relative" : "w-full"}`}>
          <div className={`${step === 2 ? "md:flex space-x-4" : ""}`}>
            <div className="w-full">
              <header className="flex justify-center bg-white">
                <HeaderStep n="01" h="Workflow" active={step === 1} />
                <HeaderStep n="02" h="Mapping" active={step === 2} />
              </header>
              {step === 1 ? (
                configurationID || tempPageName === "manage workflow" ? (
                  <UpdateFirstStep setStep={setStep} step={step} />
                ) : (
                  <FirstStep
                    setStep={setStep}
                    createTask={handleCreateTask}
                    createConfiguration={handleCreateConfiguration}
                    error={error}
                    taskItem={taskItem}
                  />
                )
              ) : (
                <>
                  <ActivityStackList
                    addRemoveAcitivity={addRemoveAcitivity}
                    activityCardList={activityCardList}
                    activityCardListForStack={activityCardListForStack}
                    setActivityCardListForStack={setActivityCardListForStack}
                  />
                  <SecondStep
                    setStep={setStep}
                    activityCardList={activityCardList}
                    handleSubmit={handleSubmit}
                    error={error}
                    tableHeightRef={tableHeightRef}
                    payloadState={payloadState}
                    setPayloadState={setPayloadState}
                    payloadData={payloadData}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

CreateConfiguration.auth = {
  path: "/configuration/create",
  role: "super-admin",
};
export default CreateConfiguration;

const ActivityStackList = ({
  addRemoveAcitivity,
  activityCardList,
  activityCardListForStack,
}) => {
  const [openTab, setOpenTab] = useState(1);

  return (
    <div className="block md:hidden space-y-4 md:w-1/3">
      <h4 className="font-extrabold text-2xl sm:text-base sm:border-b sm:p-4">
        Tasks
      </h4>
      <div className="sm:p-2">
        <SearchForm placeholder="Search activity" />
      </div>
      {/* Tabs */}
      <div className="mt-2 block md:hidden max-h-80 overflow-y-auto">
        <ul
          className="nav nav-tabs nav-justified flex flex-row flex-wrap pl-0 mb-4"
          id="tabs-tabJustify"
          role="tablist"
        >
          <li className="nav-item flex-grow text-center">
            <a
              href="#tabAdded"
              className={
                "nav-link w-full block font-medium leading-5 text-sm uppercase border-b-2 px-6 py-4 my-3" +
                (openTab === 1
                  ? "border-[--bg-color-500] text-[--bg-color-500] font-bold"
                  : null)
              }
              id="tab-added"
              data-toggle="tab"
              role="tablist"
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(1);
              }}
            >
              added
            </a>
          </li>
          <li className="nav-item flex-grow text-center">
            <a
              href="#tabNotadded"
              className={
                "nav-link w-full block font-medium leading-5 text-sm uppercase border-b-2 px-6 py-4 my-3" +
                (openTab === 2
                  ? "border-b-2 border-[--bg-color-500] text-[--bg-color-500] font-bold"
                  : null)
              }
              id="tab-added"
              data-toggle="tab"
              role="tablist"
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(2);
              }}
            >
              not added
            </a>
          </li>
        </ul>
        <div
          id="tabAdded"
          className={openTab === 1 ? "block space-y-2" : "hidden"}
        >
          {activityCardList.map((element, index) => (
            <div
              className="bg-blue-50 h-16 flex flex-col justify-center"
              onClick={() => {
                addRemoveAcitivity(element, index);
              }}
            >
              <div className="flex justify-between px-6">
                <h1 className="text-sm font-semibold leading-6">
                  {element.name}
                </h1>
              </div>
              <div className="flex justify-between px-6">
                <p className="text-xs leading-5">{element.description}</p>
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="check-circle"
                  class="w-4 h-4 mr-2 fill-current"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                  ></path>
                </svg>
              </div>
            </div>
          ))}
        </div>
        <div
          id="tabNotadded"
          className={openTab === 2 ? "block space-y-2" : "hidden"}
        >
          {activityCardListForStack.map((element, index) => (
            <div
              className="bg-neutral-100 h-16 flex flex-col justify-center"
              onClick={() => {
                addRemoveAcitivity(element, index);
              }}
            >
              <div className="flex justify-between px-6">
                <h1 className="text-sm font-semibold"> {element.name}</h1>
              </div>
              <div className="flex justify-between px-6">
                <p className="text-xs">{element.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const HeaderStep = ({ n, h, p, active }) => {
  let cssClass =
    "flex justify-center items-center w-10 h-10 rounded-full border-2 ";
  if (active) cssClass += "text-[--bg-color-500] border-[--bg-color-500]";

  return (
    <div className="flex justify-center sm:justify-start items-center space-x-3 w-1/2 p-2 border-slate-200 border-[1px]">
      <span className={cssClass}>{n}</span>
      <div className="hidden sm:block">
        <h4 className="font-medium">{h}</h4>
        <p className="font-normal hidden sm:block">{p}</p>
      </div>
    </div>
  );
};

const FirstStep = ({ createTask, setStep, createConfiguration, taskItem }) => {
  const [configurations, setConfigurations] = useState([]);
  const [toBeEdited, setToBeEdited] = useState(null);
  const [configurationName, setConfigurationName] = useState("");
  const [description, setDescription] = useState("");
  const [headerName, setheaderName] = useState(null);
  const [configurationValue, setConfigurationValue] = useState(null);
  const [update, setUpdate] = useState(0);
  const { tempPageName } = useSelector((state) => state.tempWindowsData);

  // Getting configuration_id from path using useLocation hook for "Copy Workflow"
  const location = useLocation();
  const parentConfigurationId = location?.state;

  // Getting dispatch and redux state
  const dispatch = useDispatch();

  const { headerList, configurationWithSettingData } = useSelector(
    (state) => state.configurationReducer
  );

  // Function to get Parent Workflow Data
  const getConfigurationData = () => {
    const request = {
      configurationID: parentConfigurationId,
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onSuccess: (data) => {
        console.log(data);
        setConfigurationName(data.configuration_name);
        setDescription(data.configuration_desc);
        if (data.configuration_settings.length > 0) {
          setConfigurations(
            data.configuration_settings.map((item) => {
              const obj = {
                id: Math.floor(Math.random() * 1000),
                name: data.configuration_name,
                label: item.header_name,
                value: item.header_value,
              };
              return obj;
            })
          );
        }
      },
    };
    dispatch(getConfigurationDataWithSetting(request));
  };

  // Validation
  const schemma = Yup.object().shape({
    configName: Yup.string()
      .max(100, "Workflow name cannot be more than 100 character long.")
      .required("This field is required"),
    configurationDesc: Yup.string().max(
      100,
      "Description cannot be more than 100 character long."
    ),
    header: Yup.string()
      .max(50, "Header cannot be more than 50 character long.")
      .nullable(),
    headerValue: Yup.string()
      .max(50, "Value cannot be more than 50 character long.")
      .nullable(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      configName: configurationName,
      configurationDesc: description,
      header: null,
      headerValue: null,
    },
    validationSchema: schemma,
    onSubmit: () => {
      if (
        Boolean(
          formik.errors.configName ||
            formik.errors.configurationDesc ||
            formik.errors.header ||
            formik.errors.headerValue
        )
      ) {
        console.log("condition is satisfied.");
        return null;
      } else {
        createTask({
          configurationName,
          description,
          headerName,
          configurationValue,
          setConfigurations,
          setheaderName,
          setConfigurationValue,
        });
        formik.resetForm();
        formik.setFieldValue("configName", configurationName);
        formik.setFieldValue("configurationDesc", description);
      }
    },
  });

  // State to show existing headerlist
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const dropdown = useRef(null);

  // State to edit the configuration setting (task)
  const [editHeaderName, setEditHeaderName] = useState();
  const [editHeaderValue, setEditHeaderValue] = useState();

  const getHeaderNameByCompanyId = () => {
    const request = {
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Header name and header value should not be empty."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getHeaderName(request));
  };

  // Function to edit existing task
  const updateTask = (
    id,
    editHeaderName,
    editHeaderValue,
    setToBeEdited,
    headerValue,
    headerLabel
  ) => {
    setConfigurations((prev) => {
      return prev.map((item) => {
        if (item.id === id && editHeaderName && editHeaderValue) {
          item.label = editHeaderName;
          item.value = editHeaderValue;
        } else if (item.id === id && editHeaderName) {
          item.label = editHeaderName;
          item.value = headerValue;
        } else if (item.id === id && editHeaderValue) {
          item.label = headerLabel;
          item.value = editHeaderValue;
        } else if (item.id === id) {
          item.label = headerLabel;
          item.value = headerValue;
        }
        return item;
      });
    });
    setToBeEdited(null);
  };

  const handleDelete = (id, index) => {
    setConfigurations(configurations.filter((a) => a.id !== id));
    taskItem.splice(index, 1);
  };

  useEffect(() => {
    getHeaderNameByCompanyId();
    if (parentConfigurationId) {
      getConfigurationData();
    }
  }, []);

  useEffect(() => {
    const checkClickedOutside = (e) => {
      // If menu is open and clicked target is not within the menu then close the menu
      if (
        dropdownOpen &&
        dropdown.current &&
        !dropdown.current.contains(e.target)
      ) {
        setdropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", checkClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkClickedOutside);
    };
  }, [dropdownOpen]);

  // Component to show suggestion box
  const DropDownButton = ({ headerList, setdropdownOpen, headerName }) => {
    let expression = `${headerName}`;
    let regexObj = new RegExp(expression, "gi");
    let headerListArr = [];

    if (headerList?.length > 0) {
      headerList.forEach((element) => {
        let output = element.header_name.match(regexObj);
        headerListArr.push(output);
      });
    }

    let set = new Set(headerListArr);
    if (set.size === 1 && set.has(null)) {
      setdropdownOpen(false);
      return null;
    }

    return (
      <>
        {headerList.map((element, index) => {
          let output = element.header_name.match(regexObj);
          if (headerName === "") {
            // setdropdownOpen(true);
            return (
              <button
                key={index}
                tabIndex="0"
                className={`flex items-center flex-nowrap w-full hover:bg-slate-50 py-1 px-3 cursor-pointer`}
                onClick={() => {
                  formik.setFieldValue("header", element.header_name);
                  setheaderName(element.header_name);
                  setdropdownOpen(false);
                }}
              >
                <span>{element.header_name}</span>
              </button>
            );
          } else if (output !== null) {
            // setdropdownOpen(true)
            return (
              <button
                key={index}
                tabIndex="0"
                className={`flex items-center flex-nowrap w-full hover:bg-slate-50 py-1 px-3 cursor-pointer`}
                onClick={() => {
                  formik.setFieldValue("header", element.header_name);
                  setheaderName(element.header_name);
                  setdropdownOpen(false);
                }}
              >
                <span>{element.header_name}</span>
              </button>
            );
          }
        })}
      </>
    );
  };

  const [checked, setChecked] = useState(false);

  const handleControlChange = () => {
    setChecked(!checked);
  };

  return (
    <div className="md:flex flex-auto h-screen">
      <div className="md:w-1/2 md:h-full w-full bg-white">
        <div className="w-full md:max-w-[400px] mx-auto pt-3">
          <form onSubmit={formik.handleSubmit} autoComplete="off">
            <InputField
              type="text"
              label="Workflow Name"
              placeholder="Enter Workflow Name"
              wrapperClass="my-5"
              required
              name="configName"
              onChange={(event) => {
                const value = sanitizeInput(event.target.value);
                setConfigurationName(value);
                formik.setFieldValue("configName", value);
                if (configurations.length > 0) {
                  setConfigurations((prev) => {
                    return prev.map((item) => {
                      return { ...item, name: value };
                    });
                  });
                }
              }}
              value={configurationName}
              onBlur={formik.handleBlur}
              // disabled={configurations.length > 0}
              error={
                Boolean(formik.touched.configName && formik.errors.configName)
                  ? formik.errors.configName
                  : null
              }
            />
            <InputField
              type="text"
              label="Description"
              placeholder="Enter Description"
              name="configurationDesc"
              wrapperClass="my-5"
              onChange={(event) => {
                const value = sanitizeInput(event.target.value);
                setDescription(value);
                formik.setFieldValue("configurationDesc", value);
              }}
              value={description}
              onBlur={formik.handleBlur}
              // disabled={configurations.length > 0}
              error={
                Boolean(
                  formik.touched.configurationDesc &&
                    formik.errors.configurationDesc
                )
                  ? formik.errors.configurationDesc
                  : null
              }
            />
            <div className="flex justify-between items-center">
              <h4 className="text-base font-bold leading-8">Use Integration</h4>
              <div className="flex items-center ml-4">
                <div className="form-switch">
                  <input
                    type="checkbox"
                    name="Advance Control Setting"
                    checked={checked}
                    onChange={handleControlChange}
                    id="controlSetting"
                    className="sr-only"
                  />
                  <label htmlFor="controlSetting" className="bg-slate-400">
                    <span
                      className="bg-white shadow-sm"
                      aria-hidden="true"
                    ></span>
                  </label>
                </div>
              </div>
            </div>
            <div className={`${checked ? "block" : "hidden"} relative w-full`}>
              <InputField
                type="text"
                label="Header Name"
                placeholder="Enter Header Name"
                wrapperClass="my-5"
                required
                name="header"
                value={headerName}
                onClick={() => setdropdownOpen(true)}
                onChange={(event) => {
                  const value = sanitizeInput(event.target.value);
                  setheaderName(value);
                  formik.setFieldValue("header", value);
                }}
                onBlur={formik.handleBlur}
                error={
                  Boolean(formik.touched.header && formik.errors.header)
                    ? formik.errors.header
                    : null
                }
              />
              <div
                className={`z-10 absolute w-full bg-white border border-slate-200 py-1.5 rounded shadow-lg overflow-hidden mt-0 ${
                  dropdownOpen ? "block" : "hidden"
                } `}
              >
                <div
                  ref={dropdown}
                  className="font-medium text-sm text-slate-600"
                >
                  <DropDownButton
                    headerList={headerList}
                    setdropdownOpen={setdropdownOpen}
                    dropdownOpen={dropdownOpen}
                    headerName={headerName}
                  />
                </div>
              </div>
            </div>
            <InputField
              type="text"
              label="Value"
              placeholder="Enter Value"
              wrapperClass={`${checked ? "block" : "hidden"} my-5`}
              value={configurationValue}
              name="headerValue"
              required
              onChange={(event) => {
                const value = sanitizeInput(event.target.value);
                setConfigurationValue(value);
                formik.setFieldValue("headerValue", value);
              }}
              onBlur={formik.handleBlur}
              error={
                Boolean(formik.touched.headerValue && formik.errors.headerValue)
                  ? formik.errors.headerValue
                  : null
              }
            />
            <div className="flex justify-end space-x-2 py-2">
              <button
                type="button"
                onClick={() => {
                  if (configurationValue && headerName) {
                    formik.handleSubmit();
                    setUpdate(update + 1);
                  } else {
                    swal({
                      content: (
                        <CustomeModal
                          type="error"
                          title="Error!"
                          content="Header name and header value should not be empty."
                        />
                      ),
                      buttons: false,
                      closeOnClickOutside: false,
                      closeOnEsc: false,
                    });
                  }
                }}
                className={`${
                  checked ? "block" : "hidden"
                } btn-sm !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white`}
              >
                Add Header
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="md:w-1/2 w-full md:h-full">
        <div className="overflow-x-auto">
          <Table
            heads={[
              {
                headName: "Name",
                isSort: false,
                value: "Name",
              },
              {
                headName: "Header name",
                isSort: false,
                value: "Header name",
              },
              {
                headName: "Value",
                isSort: false,
                value: "Value",
              },
              {
                headName: "Action",
                isSort: false,
                value: "Action",
              },
            ]}
            tClass="table-auto w-full"
            hClass="text-xs font-semibold uppercase text-slate-500 bg-white border-t border-b border-slate-200 w-10"
            bClass="text-sm divide-y divide-slate-200"
            thClass="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold "
          >
            {configurations.map(({ id, name, label, value }, i) => (
              <TableRow
                key={i}
                row={{ name }}
                tdClass="px-2 whitespace-nowrap text-indigo-00 first:text-[--bg-color-500] "
              >
                <td className="px-2 py-3 whitespace-nowrap">
                  {toBeEdited === id ? (
                    <input
                      type="text"
                      name="headername"
                      id="#headerName"
                      className="w-3/4"
                      defaultValue={label}
                      onChange={(event) => {
                        const value = sanitizeInput(event.target.value);
                        setEditHeaderName(value);
                      }}
                      value={editHeaderName}
                    />
                  ) : (
                    label
                  )}
                </td>
                <td className="px-2 py-3 whitespace-nowrap">
                  {toBeEdited === id ? (
                    <input
                      type="text"
                      name="headername"
                      id="#headerName"
                      className="w-3/4"
                      defaultValue={value}
                      onChange={(event) => {
                        const value = sanitizeInput(event.target.value);
                        setEditHeaderValue(value);
                      }}
                      value={editHeaderValue}
                    />
                  ) : (
                    value
                  )}
                </td>
                <td className="flex space-x-2 px-2 py-3 whitespace-nowrap">
                  {toBeEdited === id ? (
                    <Submit
                      tag="button"
                      type="button"
                      title="Submit"
                      onClick={() =>
                        updateTask(
                          id,
                          editHeaderName,
                          editHeaderValue,
                          setToBeEdited,
                          value,
                          label
                        )
                      }
                    />
                  ) : (
                    <div title="Edit">
                      <span
                        className="fa-light fa-pen text-base cursor-pointer"
                        style={{ color: "#9297a2" }}
                        onClick={() => setToBeEdited(id)}
                      ></span>
                    </div>
                  )}

                  <div title="Delete">
                    <span
                      className="fa-light fa-trash-can text-base cursor-pointer"
                      style={{ color: "#eb5757" }}
                      onClick={() => {
                        swal({
                          content: (
                            <CustomeModal
                              type="delete"
                              title="Are you sure?"
                              content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                              onDelete={() => handleDelete(id, i)}
                            />
                          ),
                          buttons: false,
                          closeOnClickOutside: false,
                          closeOnEsc: false,
                        });
                      }}
                    ></span>
                  </div>
                </td>
              </TableRow>
            ))}
          </Table>
        </div>

        <div className="flex justify-end space-x-2 m-1.5">
          <Link
            to="/workflows"
            onClick={() => {
              setStep(1);
              dispatch({ type: REMOVE_CONFIGURATION_ID, payload: undefined });
              if (tempPageName === "manage workflow") {
                dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
              }
            }}
            className="btn-sm border-slate-200 hover:border-slate-300 text-slate-600"
          >
            Cancel
          </Link>
          <button
            type="button"
            onClick={() => {
              if (formik.errors.configName || formik.errors.configurationDesc) {
                return null;
              } else {
                createConfiguration({
                  configurationName,
                  description,
                  setStep,
                  configurations,
                });
              }
            }}
            className="btn-sm !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
          >
            {parentConfigurationId ? "Copy" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

const UpdateFirstStep = ({ step, setStep }) => {
  const [toBeEdited, setToBeEdited] = useState(null);
  const [update, setupdate] = useState(0);
  const [headerName, setHeaderName] = useState();

  const dispatch = useDispatch();
  const { headerList, configurationID, configurationWithSettingData } =
    useSelector((state) => state.configurationReducer);
  const { tempPageName } = useSelector((state) => state.tempWindowsData);

  const [headerValue, setHeaderValue] = useState();
  const [dropdownOpen, setdropdownOpen] = useState(false);

  // State to add new configurationn setting
  const [newHeaderName, setNewHeaderName] = useState(null);
  const [newHeaderValue, setNewHeaderValue] = useState(null);

  // State to show existing headerlist
  const dropdown = useRef(null);

  // Validation
  const schemma = Yup.object().shape({
    configName: Yup.string()
      .max(100, "Workflow name cannot be more than 100 character long")
      .required("This field is required"),
    configurationDesc: Yup.string().max(
      100,
      "Description cannot be more than 100 character long"
    ),
    header: Yup.string()
      .max(50, "Header cannot be more than 50 character long")
      .nullable(),
    headerValue: Yup.string()
      .max(50, "Value cannot be more than 50 character long")
      .nullable(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      configName: configurationWithSettingData?.configuration_name,
      configurationDesc: configurationWithSettingData?.configuration_desc,
      header: "",
      headerValue: "",
    },
    validationSchema: schemma,
    onSubmit: () => {
      if (
        !Boolean(
          formik.errors.configName &&
            formik.errors.configurationDesc &&
            formik.errors.header &&
            formik.errors.headerValue
        )
      ) {
        createTask({
          newHeaderName,
          newHeaderValue,
          setNewHeaderName,
          setNewHeaderValue,
          setupdate,
          update,
        });
        formik.resetForm();
      }
    },
  });

  const getConfigurationData = () => {
    if (step === 1) {
      const request = {
        configurationID,
        onError: () => {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content="Something went wrong. Please try again later."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        },
      };
      dispatch(getConfigurationDataWithSetting(request));
    }
  };

  const getHeaderNameByCompanyId = () => {
    if (step === 1) {
      const request = {
        onError: () => {
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content="Header name and header value should not be empty."
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        },
      };
      dispatch(getHeaderName(request));
    }
  };

  const handleDelete = (id) => {
    const request = {
      id,
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onSuccess: () => {
        setupdate(update + 1);
      },
    };

    dispatch(handleDeleteConfigurationSetting(request));
  };

  const handleUpdate = (
    headerName,
    headerValue,
    setHeaderValue,
    setHeaderName
  ) => {
    let data;
    if (headerName && headerValue) {
      data = {
        header_name: headerName,
        header_value: headerValue,
      };
    } else if (headerName) {
      data = {
        header_name: headerName,
      };
    } else if (headerValue) {
      data = {
        header_value: headerValue,
      };
    } else {
      setToBeEdited(null);
      setHeaderValue();
      setHeaderName();
      return null;
    }

    const body = JSON.stringify(data);

    const request = {
      body,
      toBeEdited,
      onSuccess: () => {
        setToBeEdited(null);
        setHeaderValue();
        setHeaderName();
        setupdate(update + 1);
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(handleUpdateConfigurationSetting(request));
  };

  const createTask = async (task) => {
    if (!task.newHeaderName && !task.newHeaderValue) {
      swal({
        content: (
          <CustomeModal
            type="error"
            title="Error!"
            content="Header name and header value should not be empty."
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      return null;
    }

    const body = {
      configuration_id: configurationID,
      header_name: task.newHeaderName,
      header_value: task.newHeaderValue,
    };

    const request = {
      body,
      onSuccess: () => {
        task.setNewHeaderName(null);
        task.setNewHeaderValue(null);
        task.setupdate(task.update + 1);
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(handleAddHeader(request));
  };

  const updateConfiguration = async (update, setUpdate) => {
    // Need to handle copy workflow logic (in copy workflow we shoulld call create workflow API not update workflow, this can be handle using state)
    if (
      formik.values.configName ===
        configurationWithSettingData?.configuration_name &&
      formik.values.configurationDesc ===
        configurationWithSettingData?.configuration_desc
    ) {
      setStep(2);
      return null;
    }

    let body;

    if (formik.values.configurationDesc) {
      body = {
        configuration_name: formik.values.configName?.trim(),
        configuration_desc: formik.values.configurationDesc?.trim(),
      };
    } else {
      body = {
        configuration_name: formik.values.configName?.trim(),
      };
    }

    const request = {
      body,
      configurationID,
      onSuccess: () => {
        setUpdate(update + 1);
        setStep(2);
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(handleUpdateConfigurationName(request));
  };

  useEffect(() => {
    getConfigurationData();
  }, [update]);

  useEffect(() => {
    if (configurationWithSettingData) {
      getHeaderNameByCompanyId();
    }
  }, [configurationWithSettingData]);

  useEffect(() => {
    const checkClickedOutside = (e) => {
      // If menu is open and clicked target is not within the menu then close the menu
      if (
        dropdownOpen &&
        dropdown.current &&
        !dropdown.current.contains(e.target)
      ) {
        setdropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", checkClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkClickedOutside);
    };
  }, [dropdownOpen]);

  const DropDownButton = ({ setdropdownOpen, dropdownOpen }) => {
    let expression = `${newHeaderName}`;
    let regexObj = new RegExp(expression, "gi");
    let headerListArr = [];

    headerList.forEach((element) => {
      let output = element.header_name.match(regexObj);
      headerListArr.push(output);
    });

    let set = new Set(headerListArr);
    if (set.size === 1 && set.has(null)) {
      setdropdownOpen(false);
      return null;
    }

    return (
      <>
        {headerList.map((headerName, index) => {
          let output = headerName.header_name.match(regexObj);
          if (newHeaderName === "") {
            return (
              <button
                key={index}
                tabIndex="0"
                className={`flex items-center flex-nowrap w-full hover:bg-slate-50 py-1 px-3 cursor-pointer`}
                onClick={() => {
                  setNewHeaderName(headerName.header_name);
                  setdropdownOpen(false);
                }}
              >
                <span>{headerName.header_name}</span>
              </button>
            );
          } else if (output !== null) {
            return (
              <button
                key={index}
                tabIndex="0"
                className={`flex items-center flex-nowrap w-full hover:bg-slate-50 py-1 px-3 cursor-pointer`}
                onClick={() => {
                  setNewHeaderName(headerName.header_name);
                  setdropdownOpen(false);
                }}
              >
                <span>{headerName.header_name}</span>
              </button>
            );
          }
        })}
      </>
    );
  };

  const [updateChecked, setUpdateChecked] = useState(false);

  const handleControlChange = () => {
    setUpdateChecked(!updateChecked);
  };

  return (
    <div className="flex h-screen">
      <div className="w-1/2 h-full bg-gray-50">
        <div className="max-w-[400px] mx-auto pt-3">
          <form onSubmit={formik.handleSubmit} autoComplete="off">
            <InputField
              type="text"
              label="Workflow Name"
              placeholder="Enter Workflow Name"
              wrapperClass="my-5"
              required
              onChange={(event) => {
                const value = sanitizeInput(event.target.value);
                formik.setFieldValue("configName", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.configName}
              error={
                Boolean(formik.touched.configName && formik.errors.configName)
                  ? formik.errors.configName
                  : null
              }
            />
            <InputField
              type="text"
              label="Description"
              placeholder="Enter Description"
              wrapperClass="my-5"
              onChange={(event) => {
                const value = sanitizeInput(event.target.value);
                formik.setFieldValue("configurationDesc", value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.configurationDesc}
              error={
                Boolean(
                  formik.touched.configurationDesc &&
                    formik.errors.configurationDesc
                )
                  ? formik.errors.configurationDesc
                  : null
              }
            />
            <div className="flex justify-between items-center">
              <h4 className="text-base font-bold leading-8">Use Integration</h4>
              <div className="flex items-center ml-4">
                <div className="form-switch">
                  <input
                    type="checkbox"
                    name="Advance Control Setting"
                    checked={updateChecked}
                    onChange={handleControlChange}
                    id="controlSetting"
                    className="sr-only"
                  />
                  <label htmlFor="controlSetting" className="bg-slate-400">
                    <span
                      className="bg-white shadow-sm"
                      aria-hidden="true"
                    ></span>
                  </label>
                </div>
              </div>
            </div>
            <div
              className={`${
                updateChecked ? "block" : "hidden"
              } relative w-full`}
            >
              <InputField
                type="text"
                label="Header Name"
                placeholder="Enter Header Name"
                wrapperClass="my-5"
                required
                value={newHeaderName}
                onClick={() => setdropdownOpen(true)}
                onChange={(event) => {
                  const value = sanitizeInput(event.target.value);
                  setNewHeaderName(value);
                  formik.setFieldValue("header", value);
                }}
                onBlur={formik.handleBlur}
                error={
                  Boolean(formik.touched.header && formik.errors.header)
                    ? formik.errors.header
                    : null
                }
              />
              <div
                className={`z-10 absolute w-full bg-white border border-slate-200 py-1.5 rounded shadow-lg overflow-hidden mt-0 ${
                  dropdownOpen ? "block" : "hidden"
                } `}
              >
                <div
                  ref={dropdown}
                  className="font-medium text-sm text-slate-600"
                >
                  <DropDownButton
                    setdropdownOpen={setdropdownOpen}
                    dropdownOpen={dropdownOpen}
                  />
                </div>
              </div>
            </div>
            <InputField
              type="text"
              label="Value"
              placeholder="Enter Value"
              wrapperClass={`${updateChecked ? "block" : "hidden"} my-5`}
              required
              value={newHeaderValue}
              onChange={(event) => {
                const value = sanitizeInput(event.target.value);
                setNewHeaderValue(value);
                formik.setFieldValue("headerValue", value);
              }}
              onBlur={formik.handleBlur}
              error={
                Boolean(formik.touched.headerValue && formik.errors.headerValue)
                  ? formik.errors.headerValue
                  : null
              }
            />
            <div className="flex justify-end space-x-2 m-1.5 py-2">
              <button
                type="button"
                onClick={() => formik.handleSubmit()}
                className={`${
                  updateChecked ? "block" : "hidden"
                } btn-sm !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white`}
              >
                Add Header
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="w-1/2 h-full ">
        <div className="overflow-x-auto">
          <Table
            heads={[
              {
                headName: "Name",
                isSort: false,
                value: "Name",
              },
              {
                headName: "Header name",
                isSort: false,
                value: "Header name",
              },
              {
                headName: "Value",
                isSort: false,
                value: "Value",
              },
              {
                headName: "Action",
                isSort: false,
                value: "Action",
              },
            ]}
            tClass="table-auto w-full"
            hClass="text-xs font-semibold uppercase text-slate-500 bg-white border-t border-b border-slate-200 w-10"
            bClass="text-sm divide-y divide-slate-200"
            thClass="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold "
          >
            {configurationWithSettingData?.configuration_settings
              ? configurationWithSettingData?.configuration_settings.map(
                  (
                    { configuration_setting_id, header_name, header_value },
                    i
                  ) => (
                    <tr>
                      <td className="px-2 py-3 whitespace-nowrap">
                        {configurationWithSettingData?.configuration_name}
                      </td>
                      <td className="px-2 py-3 whitespace-nowrap">
                        {toBeEdited === configuration_setting_id ? (
                          <input
                            type="text"
                            name="headername"
                            id="#headerName"
                            className="w-3/4"
                            defaultValue={header_name}
                            onChange={(event) => {
                              const value = sanitizeInput(event.target.value);
                              setHeaderName(value);
                            }}
                          />
                        ) : (
                          header_name
                        )}
                      </td>
                      <td className="px-2 py-3 whitespace-nowrap">
                        {toBeEdited === configuration_setting_id ? (
                          <input
                            type="text"
                            name="headername"
                            id="#headerName"
                            className="w-3/4"
                            defaultValue={header_value}
                            onChange={(event) => {
                              const value = sanitizeInput(event.target.value);
                              setHeaderValue(value);
                            }}
                          />
                        ) : (
                          header_value
                        )}
                      </td>
                      <td className="flex space-x-1 px-2 py-3 whitespace-nowrap">
                        {toBeEdited === configuration_setting_id ? (
                          <Submit
                            tag="button"
                            type="button"
                            title="Submit"
                            onClick={() =>
                              handleUpdate(
                                headerName,
                                headerValue,
                                setHeaderValue,
                                setHeaderName
                              )
                            }
                          />
                        ) : (
                          <div title="Edit">
                            <span
                              className="fa-light fa-pen text-base cursor-pointer"
                              style={{ color: "#9297a2" }}
                              onClick={() =>
                                setToBeEdited(configuration_setting_id)
                              }
                            ></span>
                          </div>
                        )}

                        <div title="Delete">
                          <span
                            className="fa-light fa-trash-can text-base cursor-pointer"
                            style={{ color: "#eb5757" }}
                            onClick={() =>
                              swal({
                                content: (
                                  <CustomeModal
                                    type="delete"
                                    title="Are you sure?"
                                    content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                                    onDelete={() =>
                                      handleDelete(configuration_setting_id)
                                    }
                                  />
                                ),
                                buttons: false,
                                closeOnClickOutside: false,
                                closeOnEsc: false,
                              })
                            }
                          ></span>
                        </div>
                      </td>
                    </tr>
                  )
                )
              : null}
          </Table>
        </div>

        <div className="flex justify-end space-x-2 m-1.5">
          <Link
            to="/workflows"
            onClick={() => {
              setStep(1);
              dispatch({ type: REMOVE_CONFIGURATION_ID, payload: undefined });
              if (tempPageName === "manage workflow") {
                dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
              }
            }}
            className="btn-sm border-slate-200 hover:border-slate-300 text-slate-600"
          >
            Cancel
          </Link>
          <button
            type="button"
            onClick={() => {
              if (formik.errors.configName || formik.errors.configurationDesc) {
                return null;
              } else {
                updateConfiguration(update, setupdate);
              }
            }}
            className="btn-sm !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

const SecondStep = ({
  setStep,
  activityCardList,
  handleSubmit,
  tableHeightRef,
  payloadState,
  setPayloadState,
  payloadData,
}) => {
  // Creatinng State for duration
  const [duration, setduration] = useState();
  const [timeDurationError, setTimeDurationError] = useState();

  // Creating state for changing payloadState when element is drag
  const [draggingState, setDraggingState] = useState();
  const { configurationID } = useSelector(
    (state) => state.configurationReducer
  );

  // Getting configuration_id from path using useLocation hook for "Copy Workflow"
  const location = useLocation();
  const parentConfigurationId = location?.state;

  if (payloadData.length === 0) {
    activityCardList.map((element, index) => {
      const obj = {
        configuration_id: configurationID,
        activity_id: element.id,
        name: element.name,
        sequence: index + 1,
        is_mandatory:
          payloadState && payloadState[index]
            ? payloadState[index].is_mandatory
            : false,
        activity_customfields_id:
          payloadState && payloadState[index]
            ? payloadState[index].activity_customfields_id
            : "",
        duration:
          payloadState && payloadState[index]
            ? payloadState[index].duration
            : "",
        loop_activity:
          payloadState && payloadState[index]
            ? payloadState[index].loop_activity
            : "",
        link_activity:
          payloadState && payloadState[index]
            ? payloadState[index].link_activity
            : "",
        is_immutable: element?.master_activity?.is_immutable,
      };
      payloadData.push(obj);
    });
  } else {
    for (
      let index = payloadData.length - 1;
      index < activityCardList.length;
      index++
    ) {
      const element = activityCardList[index];

      const obj = {
        configuration_id: configurationID,
        activity_id: element.id,
        name: element.name,
        sequence: index + 1,
        is_mandatory:
          payloadState && payloadState[index]
            ? payloadState[index].is_mandatory
            : false,

        activity_customfields_id:
          payloadState && payloadState[index]
            ? payloadState[index].activity_customfields_id
            : "",
        duration:
          payloadState && payloadState[index]
            ? payloadState[index].duration
            : "",
        loop_activity:
          payloadState && payloadState[index]
            ? payloadState[index].loop_activity
            : "",
        link_activity:
          payloadState && payloadState[index]
            ? payloadState[index].link_activity
            : "",
        is_immutable: element?.master_activity?.is_immutable,
      };
      payloadData.push(obj);
    }
  }

  useEffect(() => {
    if (payloadData) {
      setPayloadState(payloadData);
    }
  }, [activityCardList]);

  const validateDurationTime = (value, index) => {
    if (/^(-)?\d+$/.test(value)) {
      setTimeDurationError();
    } else {
      setTimeDurationError(index);
    }
  };

  const handleChange = (event, activityID, fieldName) => {
    setPayloadState((prev) => {
      return prev.map((ele, index) => {
        if (
          ele.activity_id === activityID &&
          fieldName === "link_activity" &&
          event.target.value.split("/").length === 1
        ) {
          ele.link_activity = event.target.value.split("/")[0];
          if (ele.activity_customfields_id) {
            delete ele.activity_customfields_id;
          }
        } else if (
          ele.activity_id === activityID &&
          fieldName === "link_activity" &&
          event.target.value.split("/").length === 2
        ) {
          ele.link_activity = event.target.value.split("/")[0];
          ele.activity_customfields_id = event.target.value.split("/")[1];
        } else if (
          ele.activity_id === activityID &&
          fieldName === "loop_activity"
        ) {
          ele.loop_activity = event.target.value;
        } else if (
          ele.activity_id === activityID &&
          fieldName === "is_mandatory"
        ) {
          ele.is_mandatory = event;
        } else if (ele.activity_id === activityID && fieldName === "duration") {
          ele.duration = event.target.value;
          validateDurationTime(event.target.value, index);
        }
        return ele;
      });
    });
  };

  useEffect(() => {
    if (duration) {
      handleChange(duration, duration.activityID, duration.fieldName);
    }
  }, [duration]);

  /*-------------------- Changing payload state when element is dragging --------------- */
  useEffect(() => {
    if (draggingState) {
      setPayloadState((prev) => {
        return prev.map((item, index) => {
          if (index === 0) {
            item.link_activity = "";
            item.activity_customfields_id = "";
            item.sequence = index + 1;
            item.duration = 0;
          } else if (index === payloadState.length - 1) {
            item.sequence = index + 1;
            item.loop_activity = "";
          } else {
            if (item.link_activity) {
              const dataIndex = payloadState.findIndex(
                (element) => element.activity_id === item.link_activity
              );
              if (dataIndex > index) {
                item.link_activity = "";
                item.activity_customfields_id = "";
                item.sequence = index + 1;
                item.duration = "";
              }
            }
            if (item.loop_activity) {
              const dataIndex = payloadState.findIndex(
                (element) => element.activity_id === item.loop_activity
              );
              if (dataIndex !== -1 && dataIndex < index) {
                item.loop_activity = "";
                item.sequence = index + 1;
              }
            }
          }
          return item;
        });
      });
    }
  }, [draggingState]);

  /* ---------------------------- Draggable and Droppable table row ---------------------------------- */
  const moveRow = (dragIndex, hoverIndex) => {
    const dragRecord = payloadState[dragIndex];
    setPayloadState(
      update(payloadState, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRecord],
        ],
      })
    );
    setDraggingState(dragIndex);
  };

  return (
    <div className="">
      <div className="overflow-x-auto" ref={tableHeightRef}>
        <DndProvider backend={HTML5Backend}>
          <table className="table-auto w-full">
            <thead className="text-sm font-semibold text-slate-500 bg-slate-50 border-t border-b border-slate-200 w-10">
              <tr>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold "></th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold">
                  To Do
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold ">
                  <div className="flex items-center space-x-2">
                    <p>Set Priority</p>
                    <Tippy content="Prioritize the tasks based on their importance.">
                      <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
                    </Tippy>
                  </div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold ">
                  <div className="flex items-center space-x-2">
                    <p>Link To Do</p>
                    <Tippy content="Link tasks will enable the tasks to automatically alter the end date and time of the next task that is linked to it. The estimated time is calculated based on the end date and time of the primary tasks.">
                      <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
                    </Tippy>
                  </div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold w-[20px]">
                  <div className="flex items-center space-x-2">
                    <p>To Do Duration (Hour)</p>
                    <Tippy content="Set the duration within which the next task needs to be performed after the completion of primary task linked to it.">
                      <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
                    </Tippy>
                  </div>
                </th>
                <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold ">
                  <div className="flex items-center space-x-2">
                    <p>Loop Dos</p>
                    <Tippy content="This will enable to set the task on loop and will not be termed as completed until and unless the looped task is completed.">
                      <span className="fas fa-info-circle fill-current text-[--bg-color-500] cursor-pointer text-sm"></span>
                    </Tippy>
                  </div>
                </th>
              </tr>
            </thead>
            {payloadState
              ? payloadState.map((row, i) => {
                  return (
                    <Row
                      index={i}
                      row={row}
                      moveRow={moveRow}
                      handleChange={handleChange}
                      payloadState={payloadState}
                      setDraggingState={setDraggingState}
                      timeDurationError={timeDurationError}
                    />
                  );
                })
              : null}
          </table>
        </DndProvider>
      </div>

      <div className="flex justify-end space-x-2 m-1.5">
        <button
          type="button"
          onClick={() => setStep(1)}
          className="btn-sm border-slate-200 hover:border-slate-300 text-slate-600"
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn-sm !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
          onClick={() =>
            !timeDurationError ? handleSubmit(payloadState) : null
          }
        >
          {parentConfigurationId ? "Copy" : "Save"}
        </button>
      </div>
    </div>
  );
};

const Row = ({
  row,
  index,
  moveRow,
  handleChange,
  payloadState,
  setDraggingState,
  timeDurationError,
}) => {
  const dropRef = useRef(null);
  const dragRef = useRef(null);
  const dropdownItm = useRef(null);
  const dropdownSubItm = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const [mainMenuItem, setMainMenuItem] = useState();
  const [subMenuItem, setSubMenuItem] = useState();
  let data;

  const { activityResponse } = useSelector((state) => state.todo);

  if (activityResponse.length > 0) {
    data = activityResponse.filter((element) => {
      return payloadState.some((el) => {
        return el.activity_id === element.id;
      });
    });
  }

  // Dropping part
  const [, drop] = useDrop({
    accept: "row",
    hover(item, monitor) {
      if (!dropRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = dropRef.current.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveRow(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });

  // Dragging Part
  const [{ isDragging }, drag, preview] = useDrag({
    type: "row",
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  // Creating dropdown
  useEffect(() => {
    const checkClickedOutside = (e) => {
      // If menu is open and clicked target is not within the menu then close the menu
      if (
        openDropdown &&
        dropdownItm.current &&
        !dropdownItm.current.contains(e.target) &&
        dropdownSubItm.current &&
        !dropdownSubItm.current.contains(e.target)
      ) {
        setOpenDropdown(false);
        setOpenSubMenu(false);
      }
    };

    document.addEventListener("mousedown", checkClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkClickedOutside);
    };
  }, [openDropdown]);

  const opacity = isDragging ? 0.6 : 1;

  preview(drop(dropRef));
  drag(dragRef);

  useEffect(() => {
    if (mainMenuItem) {
      const ele = data
        .filter((item) => item.id === mainMenuItem)[0]
        .activitycustomfields.filter(
          (item) => item.type === "date" || item.type === "datetime"
        );

      setSubMenuItem(ele);
      if (ele.length > 0) {
        setOpenSubMenu(true);
      }
    }
  }, [mainMenuItem]);

  const validateDurationRejx = (event) => {
    const keyCode = event.which || event.keyCode;
    const validKey =
      (keyCode >= 48 && keyCode <= 57) || // 48-57: numbers
      keyCode === 8 || // Backspace
      keyCode === 45 || // Minus sign (regular keyboard)
      keyCode === 109 || // Minus sign (numeric keypad)
      keyCode === 189 || // Minus sign (regular keyboard)
      (keyCode >= 96 && keyCode <= 105); // 96-105: numbers from numeric keypad

    if (!validKey) {
      event.preventDefault();
    }
  };

  const getLoopActivityValue = (row) => {
    if (row.loop_activity) {
      return row.loop_activity;
    } else {
      return "Select Loop To Do";
    }
  };

  return (
    <tr
      ref={dropRef}
      className="px-2 py-3 whitespace-nowrap"
      key={index}
      style={{ opacity }}
    >
      <td
        ref={dragRef}
        className="px-2 py-3 whitespace-nowrap cursor-pointer"
        onMouseLeave={(e) => {
          setDraggingState(null);
        }}
      >
        <svg
          class="h-8 w-8 text-gray-300"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="21" y1="10" x2="3" y2="10" />{" "}
          <line x1="21" y1="6" x2="3" y2="6" />{" "}
          <line x1="21" y1="14" x2="3" y2="14" />{" "}
          <line x1="21" y1="18" x2="3" y2="18" />
        </svg>
      </td>
      <td className="px-2 py-3 whitespace-nowrap text-shovel">{row.name}</td>
      <td className="px-2 py-2 whitespace-nowrap">
        <div className="w-full flex justify-center">
          <input
            type="checkbox"
            className={`form-checkbox cursor-pointer`}
            // value={row.is_mandatory}
            checked={row.is_mandatory}
            onChange={(e) =>
              handleChange(!row.is_mandatory, row.activity_id, "is_mandatory")
            }
          />
        </div>
      </td>
      <td className="px-2 py-2 whitespace-nowrap">
        {index === 0 ? (
          <p className="text-sm leading-5 tracking-tight">
            Cannot select link To Do
          </p>
        ) : (
          <select
            name="link act"
            id={row.activity_id}
            className={`w-full rounded-md border-2 border-gray-200 border-r-4 active:border-gray-200 focus:border-gray-200`}
            // value={row.link_activity}
            value={
              row.link_activity && row.activity_customfields_id
                ? `${row.link_activity}/${row.activity_customfields_id}`
                : row.link_activity
            }
            onChange={(e) => handleChange(e, row.activity_id, "link_activity")}
          >
            <option value="">
              {index === 0 ? "Cannot select link To Do" : "Select Link To Do"}
            </option>
            {payloadState.slice(0, index).map((element) => {
              const subMenu = data
                ?.filter((item) => item.id === element.activity_id)[0]
                ?.activitycustomfields?.filter(
                  (item) => item?.todo_component?.type === "date/time"
                );

              if (subMenu?.length > 0) {
                return subMenu.map((menu, index) => {
                  return index == 0 ? (
                    <>
                      <option value={element.activity_id}>
                        {element.name}
                      </option>
                      <option
                        value={`${element.activity_id}/${menu.id}`}
                        disabled={!menu.is_required}
                        className={`${!menu.is_required && "text-slate-300"}`}
                      >
                        {element.name} - {menu.todo_component?.label}
                      </option>
                    </>
                  ) : (
                    <option
                      value={`${element.activity_id}/${menu.id}`}
                      disabled={!menu.is_required}
                      className={`${!menu.is_required && "text-slate-300"}`}
                    >
                      {element.name} - {menu.todo_component?.label}
                    </option>
                  );
                });
              }
              return (
                <option value={element.activity_id}>{element.name}</option>
              );
            })}
          </select>
        )}
      </td>
      <td className="px-2 py-2 whitespace-nowrap">
        {row.link_activity && index !== 0 && (
          <>
            <input
              type="number"
              name="time"
              id="time"
              placeholder="Hours"
              // min={0}
              value={row.duration}
              onChange={(e) => handleChange(e, row.activity_id, "duration")}
              onKeyDown={validateDurationRejx}
              className="w-full rounded-md border-2 border-gray-200 border-r-4 active:border-gray-200 focus:border-gray-200"
            />
            {timeDurationError === index && (
              <div className="text-xs mt-1 text-rose-500">
                Invalid Duration.
              </div>
            )}
          </>
        )}
      </td>
      <td className="px-2 py-2 whitespace-nowrap">
        {index === payloadState.length - 1 ? (
          <p className="text-sm leading-5 tracking-tight text-center">
            Cannot select loop To Do
          </p>
        ) : (
          <select
            name="link act"
            id={index}
            className={`w-full rounded-md border-2 border-gray-200 border-r-4 active:border-gray-200 focus:border-gray-200 ${
              row.is_immutable && "bg-slate-200"
            }`}
            value={getLoopActivityValue(row)}
            onChange={(e) => handleChange(e, row.activity_id, "loop_activity")}
            disabled={row.is_immutable}
          >
            <option value="">
              {index === payloadState.length - 1
                ? "Cannot select loop To Do"
                : "Select Loop To Do"}
            </option>
            {payloadState.slice(index + 1).map((element) => {
              return (
                <option value={element.activity_id}>{element.name}</option>
              );
            })}
          </select>
        )}
      </td>
    </tr>
  );
};
